import { render, staticRenderFns } from "./totalHome.vue?vue&type=template&id=0f151c37&"
import script from "./totalHome.vue?vue&type=script&lang=ts&"
export * from "./totalHome.vue?vue&type=script&lang=ts&"
import style0 from "./totalHome.vue?vue&type=style&index=0&id=0f151c37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports